import { useInternalUsersQuery } from "src/hooks/useInternalUsers.generated";

export function useInternalUsers() {
  const { data, loading } = useInternalUsersQuery({ fetchPolicy: "cache-first" });

  return { internalUsers: data?.internalUsers ?? [], loading };
}
